import people from '@/assets/people.png';
import buildMemberProfiles from '../buildMemberProfiles';
import { envConfig } from '../../../config/env';

const { cdnBase } = envConfig;

const getPhoto = (slug) => {
  try {
    return `${cdnBase}/members/${slug}.jpg`;
  } catch (error) {
    return people;
  }
};

export default {
    breadcrumb: {
      home: 'Home',
      current: 'Members',
    },
    profileLabels: {
      biography: 'Biography',
      affiliation: 'Affiliation',
      contacts: 'Contact & Links',
    },
    profileFallback: {
      heading: 'Profile unavailable',
      message: 'We could not find this member profile. It may have moved or is being updated.',
      actions: {
        members: 'Back to Members',
        home: 'Go Home',
      },
    },
    // 成员列表与详情（统一数据来源）
    ...(() => {
      const roster = [
        {
          heading: 'Teachers',
          members: [
            {
              slug: 'gao-boyu',
              name: 'BoYu Gao',
              title: 'Doctoral Supervisor',
              note: 'Virtual reality, human-computer interaction, artificial intelligence and smart education, application security',
              image: getPhoto('gao-boyu'),
              profile: {
                summary: 'Virtual reality, human-computer interaction, artificial intelligence and smart education, application security',
                affiliation: {
                  role: '',
                  institution: 'School of Cyberspace Security, Jinan University; Guangdong Institute of Smart Education',
                },
                bio: [
                  'Gao Boyu is an associate professor and master\'s supervisor at the School of Cyberspace Security, Jinan University, and assistant to the dean of the Guangdong Institute of Smart Education. Since 2011, he has been engaged in research on trustworthy multi-channel interaction in virtual reality at the DCRC research center of Konkuk University in South Korea (director: Prof. Jee-In Kim, CHI 2015 Local Hero) and the VR Laboratory (director and advisor: Prof. Hyung Seok Kim). As a core member, he has participated in several major research projects funded by the National Research Foundation of Korea. After receiving his PhD in 2018, he stayed on at Konkuk University, and later joined Jinan University as an associate professor. He has led more than ten research projects, including General Programs of the National Natural Science Foundation of China, sub-projects of the National Key R&D Program of China, Youth Programs of the National Natural Science Foundation of China, General Programs of the Natural Science Foundation of Guangdong Province, Young Scientists Programs of Guangzhou Basic and Applied Basic Research, and industry collaboration projects.',
                  'He has published more than 30 papers in international journals and conferences. Among them, 26 SCI-indexed or CCF-listed journal and conference papers are as first or corresponding author, including IEEE VR (CCF Class A conference), IEEE Transactions on Visualization and Computer Graphics (CCF Class A journal), International Journal of Human-Computer Studies (CCF Class A journal), IEEE Transactions on Human-Machine Systems (CCF Class B journal), International Journal of Human-Computer Interaction (CCF Class B journal), and the applied computer journal IEEE Transactions on Industrial Informatics (Top journal in the first quartile of the Chinese Academy of Sciences). He has received the HHME 2023 CHCI Best Paper Award, the Best Paper Award at the Korea Computer Congress 2019, the 2019 Wu Yufu Science and Technology Innovation Education Award, and the Third Prize of the 2021 Science and Technology Progress Award of the Guangdong Computer Society, among others.'
                ],
                contacts: [
                  { label: 'Email', url: 'mailto:bygao@jnu.edu.cn', icon: 'mail' },
                  {
                    label: 'Google Scholar',
                    url: 'https://scholar.google.co.kr/citations?user=mXbw1cAAAAAJ&hl=en',
                    icon: 'scholar',
                  },
                ],
              },
            },
            {
              slug: 'wan-tingjie',
              name: 'Tingjie Wan',
              title: 'Lecturer',
              note: 'Virtual reality, human-computer interaction, interaction design, smart education',
              image: getPhoto('wan-tingjie'),
              profile: {
                summary: 'Virtual reality, human-computer interaction, interaction design, smart education',
                affiliation: {
                  role: '',
                  institution: 'Guangdong Institute of Smart Education',
                },
                bio: [
                  'Wan Tingjie is a lecturer and Qinglan Scholar at the Guangdong Institute of Smart Education, Jinan University. She obtained her PhD in Computer Science and Software Engineering from the University of Liverpool. Her main research interests are virtual reality (VR) and human-computer interaction (HCI), as well as their applications in educational scenarios. She has published several papers in top HCI conferences and journals such as CHI (CCF Class A conference), TVCG (CCF Class A journal), IEEE VR (CCF Class A conference), and IEEE ISMAR (CCF Class B conference). She received a Best Paper Nomination at ISMAR 2024.'
                ],
                contacts: [
                  { label: 'Email', url: 'mailto:tjwan@jnu.edu.cn', icon: 'mail' },
                  {
                    label: 'Google Scholar',
                    url: 'https://scholar.google.com/citations?user=HdKn7xcAAAAJ',
                    icon: 'scholar',
                  },
                ],
              },
            },
          ],
        },
        {
          heading: 'Students',
          members: [
            {
              slug: 'mai-zijun',
              name: 'Zijun Mai',
              title: 'PhD Student',
              note: 'Virtual reality',
              image: getPhoto('mai-zijun'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:zijunmai@stu2023.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'li-binghui',
              name: 'Binghui Li',
              title: 'PhD Student',
              note: 'Virtual reality',
              image: getPhoto('li-binghui'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:libinghui927@gmail.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'pan-jian',
              name: 'Jian Pan',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('pan-jian'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:1289682586@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'ye-guanyu',
              name: 'Guanyu Ye',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('ye-guanyu'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'ma-qizi',
              name: 'Qizi Ma',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('ma-qizi'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:1272298369@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'yu-yongsong',
              name: 'Yongsong Yu',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('yu-yongsong'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:153481783@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'yang-jianwei',
              name: 'Jianwei Yang',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('yang-jianwei'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:2425375336@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'zheng-zibo',
              name: 'Zibo Zheng',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('zheng-zibo'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:qitiantaile@stu2024.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'tan-minming',
              name: 'Minming Tan',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('tan-minming'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'chi-junlin',
              name: 'Junlin Chi',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('chi-junlin'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:2623135403@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'wu-yizhi',
              name: 'Yizhi Wu',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('wu-yizhi'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:17538569450@163.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'guo-yingxin',
              name: 'Yingxin Guo',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('guo-yingxin'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:2414474238@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'zhou-jungu',
              name: 'Jungu Zhou',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('zhou-jungu'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:2432153945@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'chen-yiming',
              name: 'Yiming Chen',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('chen-yiming'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:whitebiana@gmail.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'fang-sicheng',
              name: 'Sicheng Fang',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('fang-sicheng'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:3152941441@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'xiong-jufeng',
              name: 'Jufeng Xiong',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('xiong-jufeng'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:jfxiong@stu2025.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'chen-zexi',
              name: 'Zexi Chen',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('chen-zexi'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:3131652317@qq.com', icon: 'mail' },
                ],
              },
            },           
            {
              slug: 'wang-chunlin',
              name: 'Chunlin Wang',
              title: 'Undergraduate Student',
              note: 'Virtual reality',
              image: getPhoto('wang-chunlin'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [
                ],
                contacts: [
                  { label: 'Email', url: 'mailto:3482372203@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'deng-yalin',
              name: 'Yalin Deng',
              title: 'Undergraduate Student',
              note: 'Virtual reality',
              image: getPhoto('deng-yalin'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [
                ],
                contacts: [
                  { label: 'Email', url: 'mailto:1553552285@qq.com', icon: 'mail' },
                ],
              },
            },
          ],
        },
        {
          heading: 'Graduates',
          members: [
            {
              slug: 'mai-zijun',
              name: 'Zijun Mai',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('mai-zijun'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:zijunmai@stu2023.jnu.edu.cn', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'wang-miao',
              name: 'Miao Wang',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('wang-miao'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'bu-zongyong',
              name: 'Zongyong Bu',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('bu-zongyong'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'shao-tong',
              name: 'Tong Shao',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('shao-tong'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'huang-zexin',
              name: 'Zexin Huang',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('huang-zexin'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'gao-yadian',
              name: 'Yadian Gao',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('gao-yadian'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'sun-weili',
              name: 'Weili Sun',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('sun-weili'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'zheng-haojun',
              name: 'Haojun Zheng',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('zheng-haojun'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'xin-weiqiang',
              name: 'Weiqiang Xin',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('xin-weiqiang'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:mail', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'feng-jiana',
              name: 'Jiana Feng',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('feng-jiana'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:1132176251@qq.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'he-yidang',
              name: 'Yidang He',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('he-yidang'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:15919662362@163.com', icon: 'mail' },
                ],
              },
            },
            {
              slug: 'li-dasheng',
              name: 'Dasheng Li',
              title: 'Master\'s Student',
              note: 'Virtual reality',
              image: getPhoto('li-dasheng'),
              profile: {
                summary: 'Virtual reality',
                affiliation: {
                  role: '',
                  institution: 'VR Lab, Jinan University',
                },
                bio: [],
                contacts: [
                  { label: 'Email', url: 'mailto:3489988586@qq.com', icon: 'mail' },
                ],
              },
            }
          ],
        },
      ];

      return {
        roster,
        profiles: buildMemberProfiles(roster),
      };
    })(),
    alumni: {
      heading: 'Alumni',
      columns: {
        name: 'Name',
        role: 'Role',
        period: 'In-lab period',
        destination: 'Next destination',
      },
      people: [
        {
          name: '冯嘉娜',
          role: '硕士研究生',
          period: '2023.09 - 2025.07',
          destination: '百度',
        },
      ],
    },
  };
